import type { EntityConfig } from '../types'

export const programProductEntity: EntityConfig = {
  id: 'program-product',
  displayName: 'Program Product',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' },
      { value: 'draft', label: 'Draft' },
      { value: 'deprecated', label: 'Deprecated' },
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'inactive', label: 'Inactive', color: 'neutral' },
      { value: 'draft', label: 'Draft', color: 'warning' },
      { value: 'deprecated', label: 'Deprecated', color: 'error' },
    ],
    mappings: {
      all: [],
      active: ['active'],
      inactive: ['inactive'],
      draft: ['draft'],
      deprecated: ['deprecated'],
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    category: { type: 'string_array', urlKey: 'category' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'search',
    'status',
    'dateRange',
  ]
}
